
import { List, Image, Radio, Space } from 'antd';
import { useEffect, useState } from 'react';
import { CloseOutlined } from '@ant-design/icons';
import { BlobDto } from '../../Repository/eventbookyapi';
import { DocumentService } from '../../Services/ImageService';
import { TextService } from '../../Services/TextService';

export const getVersionedImageUri = (uri: string, lastModified?: Date | null) => {
    return lastModified ? uri + "?v=" + new Date(lastModified).getTime() : uri;
}

const ImageSelect = (props: any) => {
    const GetText = TextService.GetText;

    const [category, setCategory] = useState(0 as number);
    const [images, setImages] = useState<BlobDto[]>([]);

    const getDownloadUrl = (dto: BlobDto) => {
        // downloadFile (not downloadImage) - this authenticated, company-scoped picker lists the
        // admin's own uploaded images, which downloadImage no longer serves (it only serves a
        // company's current logo or an event's current banner, to stay safe for anonymous callers).
        return props.isPublicImage ? dto.uri! : process.env.REACT_APP_API_URL + '/Image/downloadFile?bloburl=' + dto.relativeUri;
    }

    // A public image re-uploaded under the same file name keeps its URL, so without a version the
    // browser (and email clients that cache by URL) keep showing the previous image. Used for the
    // URL handed to onImageSelect too, so the version ends up in the saved email/template.
    const getVersionedUrl = (dto: BlobDto) => {
        const url = getDownloadUrl(dto);
        return props.isPublicImage ? getVersionedImageUri(url, dto.lastModified) : url;
    }

    const filterImages = (isPublicImage: boolean) => {
        const filteredImages = props.images.filter((item: BlobDto) => item.isPublicImage === isPublicImage);
        setImages(images => ([
            ...filteredImages
        ]));
    }

    const deleteImage = async (item: BlobDto) => {
        await DocumentService.DeleteBannerImage(item.relativeUri!);
        props.loadImages();
    }

    useEffect(() => {
        if (category == 1) {
            filterImages(true);
        }
        else if (category == 2) {
            filterImages(false);
        }
        else {
            setImages(props.images);
        }
    }, [category, props]);
    return (
        <>
            {props.isPublicImage ? "" : <Radio.Group defaultValue={0} onChange={(e) => { setCategory(e.target.value) }}>
                <Space direction="horizontal" onClick={() => { }}>
                    <Radio value={0}>{GetText("ImageSelect_All")}</Radio>
                    <Radio value={1}>{GetText("ImageSelect_PublicPhotos")}</Radio>
                    <Radio value={2}>{GetText("ImageSelect_MyPhotos")}</Radio>
                </Space>

            </Radio.Group>}
            <List
                grid={{ gutter: 18, column: 4 }}
                dataSource={images}
                renderItem={(item: BlobDto) => (

                    <List.Item onClick={(e) => { props.onImageSelect(getVersionedUrl(item)) }}>
                        <Image className={props.selectedImage && props.selectedImage.indexOf(item.relativeUri) != -1 ? "image-selected" : ""} width={200} height={130} preview={false} style={{ padding: "10px" }} src={getVersionedUrl(item)} ></Image>
                        {props.selectedImage && props.selectedImage.indexOf(item.relativeUri) != -1 ? <CloseOutlined alt="Delete image" style={{ zIndex: "9999", right: 0, top: 0, color: "red", fontSize: "19px", position: "absolute", marginTop: "5px", marginRight: "5px" }} onClick={() => deleteImage(item)} /> : ""}
                    </List.Item >
                )}
            />
        </>)
};

export default ImageSelect;